import request from "@/api/request";
export function insertUserInfo(data) {
    return request({
        url: '/kms/userInfo' ,
        method: 'post',
        data: data
    })
}